import React, { useEffect, useState } from 'react';
import { Checkbox, Collapse, CollapseProps, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import AccountingLinkUserLoginListItemDTO from 'src/models/generated/AccountingLinkUserLoginListItemDTO';

export interface AccountLinkUserLoginTableProps {
  data?: AccountingLinkUserLoginListItemDTO[];
  loading?: boolean;
}

const AccountLinkUserLoginTable: React.FC<AccountLinkUserLoginTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<AccountingLinkUserLoginListItemDTO>[] = [
    TableColumnBuilder.Create<AccountingLinkUserLoginListItemDTO>('userLogin', 'User Login')
      .Width(400)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AccountingLinkUserLoginListItemDTO>('dataLinkLocation', 'Data Link Location')
      .Width(300)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AccountingLinkUserLoginListItemDTO>('comment', 'Comment')
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<AccountingLinkUserLoginListItemDTO>('disabled', 'Disabled')
      .Width(100)
      .Align('center')
      .AddRenderer('Custom', (val) => <Checkbox disabled checked={val}></Checkbox>)
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='account-linkuser-login-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Accounting Link User Logins</h3>}>
        <Table
          rowKey={NameOf<AccountingLinkUserLoginListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default AccountLinkUserLoginTable;
